import AttachFileIcon from '@mui/icons-material/AttachFile';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Button } from '../../Button/Button.tsx';

export type ChatAttachementsProps = {
  attachments: File[];
  onUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onRemove: (file: File) => void;
};

const StyledVisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export function ChatAttachements({ attachments, onUpload, onRemove }: ChatAttachementsProps) {
  return (
    <Stack
      direction="row"
      sx={{
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        {attachments.map(file => (
          <Button
            variant="text"
            color="error"
            size="small"
            key={file.name}
            onClick={() => onRemove(file)}
            sx={{ ':focus-visible': { backgroundColor: theme => theme.palette.error.light } }}
          >
            <Typography
              variant="body2"
              sx={{
                color: 'text.secondary',
              }}
            >
              {file.name}
            </Typography>
          </Button>
        ))}
      </Stack>
      <IconButton component="label" tabIndex={-1} aria-label="Upload files">
        <AttachFileIcon />
        <StyledVisuallyHiddenInput type="file" onChange={onUpload} multiple />
      </IconButton>
    </Stack>
  );
}
